
  import LoginAndRegistrationDialog from '@/components/organization/LoginAndRegistrationDialog';
  export default {
    name: 'DefaultDrawerMobile',
    components: {
      OrganizationMobileMenu: () =>
        import('@/components/elements/OrganizationMobileMenu'),
      SocialIcons: () => import('@/components/SocialIcons'),
      LoginAndRegistrationDialog,
    },
    props: {
      drawer: {
        type: Boolean,
        default: true,
      },
      menuItems: {
        type: Array,
        default: () => [],
      },
      mainLogo: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      title: 'Mobile Menu',
      switchToJobProviderTitle: 'Zu Jobanbieter wechseln',
      internalDrawer: true,
      iconColor: 'primaryYellow--text',
      jobProviderLoginUrl: process.env.NUXT_ENV_LEGACY_URL,
      loginMenuModel: false,
      registerMenuModel: false,
    }),
    watch: {
      drawer() {
        this.internalDrawer = this.drawer;
      },
    },
    created() {
      this.internalDrawer = this.drawer;
    },
    methods: {
      redirectToOrganizationPageLogin() {
        window.open(this.jobProviderLoginUrl, '_blank');
      },
      toggleDrawer() {
        this.$emit('toggle-drawer');
      },
    },
  };
